import { useKeycloak } from 'src/components/AuthHOC';
import { ContactUs } from './ContactUs';
import { useQuery } from '@tanstack/react-query';
import { fetchUserProfileData } from 'src/api/queries';
import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from '@chakra-ui/react';

const ContactUsWithAuth = ({
  setIsOpen
}: {
  setIsOpen: (arg1: boolean) => void;
}) => {
  const { currentUser } = useKeycloak();
  const { data: userProfile } = useQuery({
    queryKey: ['user-profile'],
    queryFn: fetchUserProfileData
  });
  const orgId = userProfile?.organizationId ?? '';
  return (
    <ContactUs currentUser={currentUser} orgId={orgId} setIsOpen={setIsOpen} />
  );
};

const ContactUsProvider = ({
  isLoggedIn,
  isOpen,
  setIsOpen
}: {
  isLoggedIn: boolean;
  isOpen: boolean;
  setIsOpen: (arg1: boolean) => void;
}) => {
  return (
    <ChakraModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      scrollBehavior="inside"
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        display="flex"
        flexDirection="column"
        width="720px"
        maxWidth="calc(100vw - 32px)"
        height="calc(100vh - 32px)"
        maxHeight="calc(100vh - 32px)"
        overflow="hidden"
      >
        <ModalCloseButton />
        <ModalBody
          padding={0}
          minHeight={0}
          flex="1 1 auto"
          height="100%"
          overflowY="scroll"
          overscrollBehaviorY="contain"
          onWheel={event => event.stopPropagation()}
        >
          {isLoggedIn ? (
            <ContactUsWithAuth setIsOpen={setIsOpen} />
          ) : (
            <ContactUs setIsOpen={setIsOpen} />
          )}
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};

export default ContactUsProvider;
